import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PageNotAccsess from '../pages/PageNotAccsess/PageNotAccsess'
import usePermission from '../hooks/usePermission'
import PrivateRouter from './PrivateRouter'
import { privateRouter, publicRouter } from './routes'
import MasterLayout from 'layouts/MasterLayout/MasterLayout'
import LayoutSetting from 'layouts/LayoutSetting/LayoutSetting'

const RouterConfig = () => {
  const { can } = usePermission()
  return (
    <BrowserRouter>
      <Routes>
        {publicRouter.map((router, key) => {
          return <Route {...router} key={key} />
        })}
        <Route element={<PrivateRouter />}>
          {privateRouter.map((router, key) => {
            const { path, element, permission, layoutSetting } = router
            const props = {
              key,
              path,
              element
            }
            if (typeof permission === 'function' && !permission(can)) {
              props.element = <PageNotAccsess />
            } else if (typeof permission === 'string' && !can(permission)) {
              props.element = <PageNotAccsess />
            }
            const Layout = layoutSetting ? LayoutSetting : MasterLayout
            return <Route {...props} key={key} element={<Layout>{element}</Layout>} />
          })}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default RouterConfig
